import {
  DecisionPage,
  HomeCalendarGranularity,
  HomeCalendarViewModel
} from "../../../models/home";
import { CalendarDateOperations } from "./calendar-date.operations";
import { CalendarEntryMapper } from "./calendar-entry.mapper";
import { CalendarPeriodBuilder } from "./calendar-period.builder";

export class CalendarAdapter {
  static toViewModel(
    page: DecisionPage | null | undefined,
    granularity: HomeCalendarGranularity,
    anchorDateKey: string,
    selectedDecisionId: string | null
  ): HomeCalendarViewModel {
    const anchorDate = CalendarDateOperations.parseDateKey(anchorDateKey);
    const todayKey = CalendarDateOperations.toDateKey(new Date());
    const { datedEntries, undatedEntries } = CalendarEntryMapper.toEntries(page?.items ?? []);
    const entriesByDay = CalendarEntryMapper.groupByDay(datedEntries);
    const selectedDayKey = datedEntries.find(
      (entry) => entry.decisionId === selectedDecisionId
    )?.dayKey ?? null;

    return {
      granularity,
      anchorDate,
      weekDayDates: CalendarPeriodBuilder.buildWeekDayDates(anchorDate),
      days: granularity === "year"
        ? []
        : CalendarPeriodBuilder.buildDays(
            granularity,
            anchorDate,
            entriesByDay,
            todayKey,
            selectedDayKey
          ),
      months: granularity === "year"
        ? CalendarPeriodBuilder.buildMonthSummaries(anchorDate, entriesByDay)
        : [],
      totalEntries: datedEntries.length,
      undatedEntries
    };
  }

  static toDateKey(value: Date | string): string {
    return CalendarDateOperations.toDateKey(value);
  }

  static parseDateKey(value?: string | null): Date {
    return CalendarDateOperations.parseDateKey(value);
  }

  static shiftAnchorDate(
    anchorDateKey: string,
    granularity: HomeCalendarGranularity,
    direction: number
  ): string {
    return CalendarDateOperations.shiftAnchorDate(anchorDateKey, granularity, direction);
  }
}
